import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { KafkaDataset } from 'app/model/dataset/kafka.dataset';
import { KafkaLinkedService } from 'app/model/linkedservice/kafka.linkedservice';

export const kafkaDatasetMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(KafkaDataset).name,
    displayName: stringResources.Kafka_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(KafkaLinkedService).name],
    isSource: false,
    isSink: false,
    datasetKind: 'unknown',
    icon: {
        className: 'svg-i-100x100-kafka'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    supportDataFlowSource: false,
    supportDataFlowSink: false
};
